export const HINT_STAGES = [
  "none",
  "gentle-hint",
  "reduced-choices",
  "replay-demonstration"
] as const;

export type HintStage = (typeof HINT_STAGES)[number];
export type ActiveHintStage = Exclude<HintStage, "none">;

export interface HintEscalationState {
  readonly stage: HintStage;
  readonly hintCount: number;
}

export interface ActiveHintEscalationState extends HintEscalationState {
  readonly stage: ActiveHintStage;
}

export type HintEscalationAction =
  | { readonly type: "advance" }
  | { readonly type: "reset" };

export function createHintEscalationState(): HintEscalationState {
  return {
    stage: "none",
    hintCount: 0
  };
}

function getNextHintStage(stage: HintStage): ActiveHintStage {
  switch (stage) {
    case "none":
      return "gentle-hint";
    case "gentle-hint":
      return "reduced-choices";
    case "reduced-choices":
    case "replay-demonstration":
      return "replay-demonstration";
  }
}

export function advanceHintEscalation(
  state: HintEscalationState
): ActiveHintEscalationState {
  return {
    stage: getNextHintStage(state.stage),
    hintCount: state.hintCount + 1
  };
}

export function reduceHintEscalation(
  state: HintEscalationState,
  action: HintEscalationAction
): HintEscalationState {
  switch (action.type) {
    case "advance":
      return advanceHintEscalation(state);
    case "reset":
      return createHintEscalationState();
  }
}
